import React, { useMemo } from 'react'
import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { userSelector } from '../../store/session'

const { TabPane } = Tabs

const RoleBasedTabs = ({ tabsConfig, ...rest }) => {
  const { user } = useSelector(userSelector)
  const userRole = useMemo(() => user?.role?.type, [user])

  const filteredTabs = tabsConfig.filter((tab) => tab.allowedRoles.includes(userRole))

  return (
    <Tabs {...rest}>
      {filteredTabs.map(({ key, tab, component }) => (
        <TabPane key={key} tab={tab}>
          {component}
        </TabPane>
      ))}
    </Tabs>
  )
}

export default RoleBasedTabs
